export class ProjectsNetworkError extends Error {
	public constructor(
		public message: string,
		public response: Response,
		public status?: number,
		public body?: any
	) {
		super(message);
		this.status = status ?? response.status;
	}
}
